import BaseService from './base.service';
import { pruneParams } from 'utils/helpers/guard-report.helper';

export default class IncidentReportService {
    static endpoint(orgId) {
        return `/orgs/${orgId}/incident-reports`;
    }

    // Reviewer inbox — cursor-paginated. Response: { data, lastId, hasMore }.
    // filters: severity, category, status, review_stage, is_violation,
    //          guard_id, location_id, property_id, from, to  (all optional)
    static async getInbox(orgId, { limit = 25, lastId, ...filters } = {}) {
        return BaseService.get(
            `${this.endpoint(orgId)}/inbox`,
            pruneParams({ limit, lastId, ...filters })
        );
    }

    // Reviewer detail — includes photos[].url (signed, ~15 min).
    static async getById(orgId, id) {
        return BaseService.get(`${this.endpoint(orgId)}/${id}`);
    }

    // Self-contained PDF — photos embedded, no signed URLs. Response is a Blob.
    static async getPdf(orgId, id) {
        return BaseService.get(`${this.endpoint(orgId)}/${id}/pdf`, {}, { responseType: 'blob' });
    }

    // Supervisor proofread edit — only while review_stage === 'supervisor'.
    // payload must contain only changed fields (see update-incident-report.dto.ts).
    static async edit(orgId, id, payload) {
        return BaseService.patch(`${this.endpoint(orgId)}/${id}`, payload);
    }

    // userId omitted → flag stays set with no linked account.
    static async setViolation(orgId, id, userId) {
        return BaseService.post(`${this.endpoint(orgId)}/${id}/violation`, userId ? { user_id: userId } : {});
    }

    static async clearViolation(orgId, id) {
        return BaseService.delete(`${this.endpoint(orgId)}/${id}/violation`);
    }

    // Supervisor → manager.
    static async approve(orgId, id) {
        return BaseService.post(`${this.endpoint(orgId)}/${id}/approve`, null);
    }

    static async acknowledge(orgId, id) {
        return BaseService.post(`${this.endpoint(orgId)}/${id}/acknowledge`, null);
    }

    // Legal from under_review (stage manager) or acknowledged. Locks the report — no reopen.
    static async close(orgId, id) {
        return BaseService.post(`${this.endpoint(orgId)}/${id}/close`, null);
    }

    // Reports flagged as violations for one account — backs the occupant profile.
    static async getViolations(orgId, userId) {
        return BaseService.get(`${this.endpoint(orgId)}/violations`, { user_id: userId });
    }
}
